import SimpleCard from "../../../../../../shared/components/SimpleCard";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { Grid, styled, Typography } from "@mui/material";
import {
  IconBrandWhatsapp,
  IconBuildingBank,
  IconEye,
  IconHeart,
  IconInfoCircle,
  IconMail,
  IconPhoneCall,
  IconPhoneRinging
} from "@tabler/icons-react";
import { Box } from "@mui/system";
import MxTypography from "@rf-l1/MxTypography";
import RemaxLogo from "@/src-refactor/assets/icons/remax-logo.svg?react";
import MxIcons from "@rf-l1/MxIcons";
import MxTooltipContent from "@rf-l1/tooltip/MxTooltipContent";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
const StatisticsCard = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const showIf = principalData.leadCounts.length > 0;
  const typeRealEstate = principalData.businesstype_id !== C_BUSINESS_TYPE.SELL.id;

  const stats = [
    {
      show: true,
      icon: <IconHeart size={24} stroke={1.5} color="#DC1C2E" />,
      label: "Me gusta",
      value: principalData.likes_counter ?? 0,
      info_text: "Cantidad de veces que los usuarios han dado like a la propiedad."
    },
    {
      show: true,
      icon: <IconEye size={24} stroke={1.5} color="#1A3668" />,
      label: "Vistas",
      value: principalData.views_counter ?? 0,
      info_text:
        "Número total de veces que los usuarios han visualizado la propiedad."
    },
    {
      show: showIf,
      icon: <IconBrandWhatsapp size={24} stroke={1.5} color="#43EB61" />,
      label: "Clic en botón de Whatsapp",
      value: principalData.getLeadCount?.("whatsapp") ?? 0,
      info_text:
        "Cantidad de veces que los usuarios han demostrado la intención de contactar por Whatsapp haciendo clic sobre el botón."
    },
    {
      show: showIf,
      icon: <IconPhoneRinging size={24} stroke={1.5} color="#535354" />,
      label: "Clic en botón de llamada",
      value: principalData.getLeadCount?.("call") ?? 0,
      info_text:
        "Número de veces que los usuarios han presionado el botón de llamar."
    },
    {
      show: showIf,
      icon: <IconMail size={24} stroke={1.5} color="#43B7FA" />,
      label: "Correos enviados por usuarios",
      value: principalData.getLeadCount?.("mail") ?? 0,
      info_text:
        "Cantidad de correos enviados por los usuarios desde el botón de enviar correo."
    },
    {
      show: showIf && typeRealEstate,
      icon: <IconBuildingBank size={20} stroke={1.5} color="#393939" />,
      label: "Referimientos hipotecarios solicitados",
      value: principalData.getLeadCount?.("mortgage referral") ?? 0,

      info_text:
        "Cantidad de veces que los usuarios han solicitado un referimiento hipotecario."
    }
  ];

  return (
    <SimpleCard title="Estadísticas" showBg={false}>
      <Container>
        <Box
          sx={{
            padding: 2,
            border: "1px solid #ddd",
            borderRadius: 2,
            width: "100%",
            margin: "0 auto"
          }}
        >
          <Grid container spacing={0}>
            {stats
              .filter(stat => stat.show)
              .map((stat, index, filteredStats) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 0",
                    borderBottom:
                      index !== filteredStats.length - 1
                        ? "1px solid #e0e0e0"
                        : "none",
                    "& svg": {
                      display: "block",
                      width: "24px",
                      height: "24px"
                    }
                  }}
                >
                  <Box
                    sx={{
                      marginRight: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    {stat.icon}
                  </Box>

                  <Grid container justifyContent={"space-between"}>
                    <Grid item display={"flex"} gap={1}>
                      <MxTypography
                        variant="caption"
                        color={"grey.700"}
                        fontWeight={400}
                      >
                        {stat.label}
                      </MxTypography>

                      <MxTooltipContent
                        template={
                          <Grid>
                            <MxTypography
                              variant="overline"
                              color="grey.700"
                              fontWeight={500}
                            >
                              {stat.info_text}
                            </MxTypography>
                          </Grid>
                        }
                      >
                        <MxIcons color="primary.main">
                          <IconInfoCircle
                            style={{ width: "14px", height: "14px" }}
                          />
                        </MxIcons>
                      </MxTooltipContent>
                    </Grid>

                    <Grid item mr={2}>
                      <MxTypography
                        variant="caption"
                        color={"primary.main"}
                        fontWeight={400}
                      >
                        {stat.value}
                      </MxTypography>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Box>

        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
          marginRight={4}
          marginTop={-2}
        >
          <Grid item>
            <MxIcons size={14}>
              <RemaxLogo />
            </MxIcons>
          </Grid>

          <Grid item xs="auto">
            <SpanText>FUENTE REMAXRD.COM</SpanText>
          </Grid>
        </Grid>
      </Container>
    </SimpleCard>
  );
};

export default StatisticsCard;

const Container = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 0.8rem;
`;

const SpanText = styled("span")(({ theme }) => ({
  fontSize: 10,
  fontWeight: 500,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.grey[600]
}));
